import { Box, Button, Card, HStack, Heading, Text, VStack } from '@chakra-ui/react';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, WarningTriangle } from 'iconoir-react';

interface ErrorStateProps {
  errorMessage: string | null;
  onBack: () => void;
  onRetry: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ errorMessage, onBack, onRetry }) => {
  const { t } = useTranslation();

  return (
    <VStack gap={6} align="stretch">
      <Card.Root rounded="xl">
        <Card.Body>
          <VStack gap={4} py={6}>
            <Box
              animation="shake 0.5s"
              css={{
                '@keyframes shake': {
                  '0%, 100%': { transform: 'translateX(0)' },
                  '25%': { transform: 'translateX(-10px)' },
                  '75%': { transform: 'translateX(10px)' },
                },
              }}
            >
              <WarningTriangle width={48} height={48} color="var(--chakra-colors-red-500)" />
            </Box>
            <VStack gap={2} textAlign="center">
              <Heading size="lg">{t('payouts.confirmation.error.title')}</Heading>
              <Text color="gray.600">
                {errorMessage || t('payouts.confirmation.error.message')}
              </Text>
            </VStack>
          </VStack>
        </Card.Body>
      </Card.Root>
      <HStack gap={3}>
        <Button variant="outline" onClick={onBack}>
          <ArrowLeft width={20} height={20} />
          {t('payouts.confirmation.error.backToPayouts')}
        </Button>
        <Button colorPalette="primary" onClick={onRetry}>
          {t('payouts.confirmation.error.tryAgain')}
        </Button>
      </HStack>
    </VStack>
  );
};
